import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { CMSLink } from '../v2/components/CMSLink'
import { Asset as AssetT, Page } from '@telesoft/types/payload-types'
import cn from 'classnames'
import React from 'react'
import { IoMdReturnRight } from 'react-icons/io'
import { RichText } from '../v2/components/RichText'

export type HeroBackgroundImageBlockProps = Extract<
  Page['hero'][0],
  { blockType: 'hero-background-image' }
>

export const DEFAULT_IMAGE_URL = '/assets/images/telesoft-abstract-46.jpg'

export default function HeroBackgroundImage(block: HeroBackgroundImageBlockProps) {
  const { title, description = false, options, image } = block
  const overlayClassName = options?.overlayClassName ?? 'opacity-80'
  const hasIcon = options?.hasIcon
  const textColour = options?.textColor
  const buttons = options?.buttons
  const isButton = buttons && buttons?.length > 0
  const titleLen = title?.length

  return (
    <div
      className={cn(
        'flex min-h-[42vh] bg-black justify-start items-end relative bg-no-repeat bg-center bg-cover',
        {
          'min-h-[64vh]': titleLen >= 80,
        },
      )}
      style={{
        backgroundImage: `url(${typeof image !== 'string' ? image?.url : DEFAULT_IMAGE_URL})`,
      }}
    >
      <div className={`absolute inset-0 bg-black ${overlayClassName}`} />
      <div
        className={`absolute inset-0 bg-gradient-to-b from-telesoft to-transparent mix-blend-soft-light`}
      />

      <Container className="mb-8 w-full">
        <div className="max-w-4xl">
          <div className="flex justify-start items-start md:items-start">
            {hasIcon && (
              <div
                className={cn('', {
                  'pt-0.5 md:pt-2 lg:pt-5': titleLen <= 18,
                  'lg:pt-2.5': titleLen >= 18,
                })}
              >
                <IoMdReturnRight className="mr-2 lg:text-xl xl:text-2xl mt-2 md:mt-1.5 text-white" />
              </div>
            )}
            <Text
              variant={titleLen >= 18 ? 'pageHeading' : 'superHeading'}
              className={`text-left ${textColour}`}
            >
              {title}
            </Text>
          </div>
          {description && (
            <>
              <div className={`border-t border-white opacity-40 my-6 lg:my-7 xl:my-8`} />

              <div className="mt-2 lg:mt-4">
                <Text variant="body" className={cn(`text-left text-base md:text-lg ${textColour}`)}>
                  <RichText content={description} className="text-white" />
                </Text>
              </div>
            </>
          )}
        </div>
        {isButton && (
          <div className="my-8 flex flex-col md:flex-row justify-start items-start space-y-4 md:space-x-8 md:space-y-0">
            {buttons.map(({ link }) => {
              return (
                <div key={`btn--map--${link.url}`} className="w-full md:w-auto">
                  <CMSLink {...link} className="text-white w-full" />
                </div>
              )
            })}
          </div>
        )}
      </Container>
    </div>
  )
}
